export default function routerStateHandler(router) {
  router.afterEach((to) => {
    if (history.state) {
      to.state = history.state;
    }
  });
}
